import {
  AutoAwesomeMosaic as AutoAwesomeMosaicIcon,
  Autorenew as AutorenewIcon,
  SubdirectoryArrowRight as SubdirectoryArrowRightIcon,
} from '@mui/icons-material';
import { Box, styled } from '@mui/material';
import { SECTION_BORDER_WIDTH } from 'src/constants';
const borderWidth = 2;

const getScaledSize = (originalSize: number, scale = 1) => {
  return originalSize * scale;
};

const getBorderStyle = ({
  theme,
  type,
  scale,
  borderWidth,
  isSelectable,
  isHover,
}: {
  type: string;
  borderWidth: number;
  theme: any;
  scale: number;
  isSelectable: boolean;
  isHover?: boolean;
}) => {
  const width = type === 'grid' ? SECTION_BORDER_WIDTH * scale : borderWidth;
  const color =
    isSelectable && isHover
      ? theme.palette.primary.dark
      : theme.palette.primary.lightest;

  return `${width}px solid ${color}`;
};

export const AssemblyScreenSectionContainer = styled(Box, {
  shouldForwardProp: (prop: any) => prop,
})(
  ({
    theme,
    width,
    height,
    type,
    $leftOffset,
    $topOffset,
    $scale,
    $selectable,
    $screenStyle,
    $initialStyle,
    $showSectionBorder,
  }) => `
  && {
    ${$initialStyle && $initialStyle};
  }
  && {
    ${$screenStyle && $screenStyle};
  }

  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  /* TODO: revisit this and remove unneeded styles */
  left: ${getScaledSize($leftOffset, $scale)}px;
  top: ${getScaledSize($topOffset, $scale)}px;
  width: ${getScaledSize(width, $scale)}px;
  height: ${getScaledSize(height, $scale)}px;
  cursor: ${$selectable ? 'pointer' : 'unset'};
  ${
    $showSectionBorder &&
    `
      border: ${getBorderStyle({
        type,
        borderWidth,
        theme,
        scale: $scale,
        isSelectable: $selectable,
      })};
      &:hover {
        border: ${getBorderStyle({
          type,
          borderWidth,
          theme,
          scale: $scale,
          isSelectable: $selectable,
          isHover: true,
        })};
    };
    `
  }
`,
);

export const AssemblyScreenSectionIconContainer = styled(Box)(
  ({ $isVertical }) => `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  ${$isVertical ? 'width: 30%;' : 'height: 30%;'}
  aspect-ratio : 1 / 1;
  min-width: 12px;
  min-height: 12px;
  max-width: 24px;
  max-height: 24px;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
  }
`,
);

export const RotateIconContainer = styled(Box)(
  ({ theme, $zIndex }) => `
  position: absolute;
  top: 1px;
  right: 4px;
  z-index: ${$zIndex};
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 50%;
  background: ${theme.palette.secondary.lightest};
`,
);

export const AutorenewIconStyled = styled(AutorenewIcon)`
  transform: rotate(90deg);
  font-size: 1rem;
  position: absolute;
  top: 2px;
  right: 2px;
`;
export const OriginalAssemblyIconContainer = styled(Box)(
  ({ theme, $zIndex }) => `
  position: absolute;
  top:1px;
  right: 25px;
  z-index: ${$zIndex};
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 50%;
  background: ${theme.palette.primary.lightest};
`,
);
export const AutoAwesomeMosaicIconStyled = styled(AutoAwesomeMosaicIcon)`
  font-size: 1rem;
  position: absolute;
  height: 15px;
  width: 15px;
  top: 2px;
  right: 2px;
`;
export const SubdirectoryArrowRightIconStyled = styled(
  SubdirectoryArrowRightIcon,
)`
  font-size: 1rem;
  position: absolute;
  height: 15px;
  width: 15px;
  top: 2px;
  right: 2px;
`;
